import { useEffect } from "react"

type UseInfiniteSizeProps<T extends { nextPageToken?: string }> = {
  autoLoad?: boolean
  data: T[] | undefined
  size: number
  setSize: (
    size: number | ((_size: number) => number)
  ) => Promise<T[] | undefined>
}

function useInfiniteSize<T extends { nextPageToken?: string }>({
  autoLoad = true,
  data,
  size,
  setSize,
}: UseInfiniteSizeProps<T>) {
  useEffect(() => {
    if (!data || !autoLoad) return

    const lastPage = data[data.length - 1]
    const hasNext = Boolean(lastPage?.nextPageToken)

    if (hasNext && data.length === size && size > 0) {
      setSize((prev) => prev + 1)
    }
  }, [data, size, setSize, autoLoad])
}

export default useInfiniteSize
